import React from 'react';
import { FilterSetController, Filter } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

const SearchModule = ({ events, ticket_office, filters, setFilters }) => {
    const { t } = useTranslation();

    const onChangeSearch = React.useCallback(
        value => {
            let tmpFilters = { ...filters };
            if (value !== '' && value !== null) {
                tmpFilters = { ...tmpFilters, search: value };
            } else {
                delete tmpFilters.search;
            }
            setFilters(tmpFilters);
        },
        [filters]
    );

    const operatorOptions = React.useMemo(() => {
        return (
            ticket_office.operators &&
            ticket_office.operators.map(o => {
                return { key: o.id, text: o.name, name: o.id };
            })
        );
    });
    const eventOptions = React.useMemo(() => {
        return (
            ticket_office.events &&
            ticket_office.events.map(e => {
                return { key: e.id, text: e.name, name: e.id };
            })
        );
    });

    return (
        <FilterSetController
            total={events?.length}
            labelTotal={t('ticket.sales_report.label_quantity', { count: events?.length })}
            labelReset={t('ticket.common.action.reset')}
            labelFilters={t('ticket.sales_report.filters')}
            initialValues={filters}
            search={{
                placeholder: t('ticket.common.action.search'),
                onChange: (synth, value) => {
                    onChangeSearch(value);
                },
                handleReset: () => {
                    onChangeSearch(null);
                },
                value: filters?.search || ''
            }}
            onChange={values => {
                if (filters.search !== undefined && filters.search.length > 0) {
                    values.search = filters.search;
                } else {
                    delete values.search;
                }
                setFilters(values);
            }}
        >
            <Filter name={'id_partner'} labelName={t('ticket.sales_report.filter.operator')} options={operatorOptions} index="1" />
            <Filter name={'id_event'} labelName={t('ticket.sales_report.filter.events')} options={eventOptions} index="2" />
        </FilterSetController>
    );
};

export default SearchModule;
